import { zClientCommonSchema } from "./client.common";
export const zClientSchemaDom = zClientCommonSchema;
export const zClientSchemaCreateDom = zClientSchemaDom.omit({ id: true });
